function useStyles() {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .flex': { display: 'flex' },
            '& .flex-1': { flex: '1 0 100px' },
            '& .flex-0': { flex: '0 1 100px' },
            '& .detail-container': {
                padding: '0px'
            },
            '& .detail-caption': {
                fontSize: '14px'
            }
        },
        detailTitle: {
            '& .detail-value': {
                fontSize: '18px',
                fontWeight: 'bold'
            },
        },
        detailItem: {
            '& .detail-value': {
                fontSize: '16px',
            },
        },
        background: {
            height: '100%',
            width: '100%',
            padding: '24px 0px',
        },
        containerEvidence: {
            backgroundColor: 'blue.100',
            height: '100%',
            width: '100%',
        },
        
        mainContainer: {
            display: 'flex', 
            flexDirection: 'column', 
            height: '100%', 
        },
        tab: {
            '&.MuiTabPanel-root':{height:'90%'}
        },
        buttonState: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
    }
}

export { useStyles }